import { useEffect} from "react";
import { useHistory, useParams } from "react-router-dom";
import classNames from "classnames";
import { Grid, Typography } from "@material-ui/core";
import useLanguage from "../hooks/useLanguage";
import useStyles from "../styles/pages/TermsStyles";
import TermsData from "../data/terms";

function Terms(props) {
  const classes = useStyles(props);
  const history = useHistory();

  const { key } = useParams();
  const numericKey = key ? Number(key) : null;
  const { key: languageKey, routeKey } = useLanguage();

  const data = numericKey
    ? TermsData.find((value) => value.key === numericKey)
    : null;

  useEffect(() => {
    if (numericKey && !data) {
      history.push(`/${routeKey}/terms`);
    }
  }, [numericKey, data, history, routeKey]);

  return (
    <Grid
      item
      container
      xs={11}
      md={11}
      className={classes.contentContainerGrid}
    >
      {key
        ? data && (
            <>
              <Grid item>
                <Typography variant="h1" className={classes.title}>
                  {data?.title?.[languageKey]}
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="body1"
                  className={classes.policy}
                  dangerouslySetInnerHTML={{
                    __html: data?.content?.[languageKey],
                  }}
                ></Typography>
              </Grid>
            </>
          )
        : TermsData.map(({ key, title, endDate }) => {
            return (
              <Grid item md={12} key={key}>
                <Typography
                  variant="h3"
                  className={classNames(classes.title, classes.underline)}
                  onClick={() => {
                    history.push(`/${routeKey}/terms/${key}`);
                  }}
                >
                  {title[languageKey]}
                </Typography>
                <Typography variant="span" className={classNames(classes.end)}>
                  {endDate[languageKey]}
                </Typography>
              </Grid>
            );
          })}
    </Grid>
  );
}

export default Terms;
